export default __webpack_public_path__ + "static/media/puff.5cb52c34.svg";